import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./style.css";

const Footer = () => {
  const { t } = useTranslation();
  
  return (
    <footer className="footer-custom">
      <div className="container">
        <div className="footer-content">
          {/* Services Column */}
          <div className="footer-column">
            <h4 className="footer-title">{t('footer.services.title')}</h4>
            <ul className="footer-links-list">
              <li><Link to="/steel">{t('navbar.steel')}</Link></li>
              <li><Link to="/marble">{t('navbar.marble')}</Link></li>
              <li><Link to="/contracting">{t('navbar.contracting')}</Link></li>
            </ul>
          </div>
          
          {/* Company Column */}
          <div className="footer-column">
            <h4 className="footer-title">{t('footer.company.title')}</h4>
            <ul className="footer-links-list">
              <li><Link to="/about">{t('navbar.about')}</Link></li>
              <li><Link to="/projects">{t('navbar.projects')}</Link></li>
              <li><Link to="/contact">{t('navbar.contact')}</Link></li>
            </ul>
          </div>
          
          {/* Contact Column */}
          <div className="footer-column">
            <h4 className="footer-title">{t('footer.contact.title')}</h4>
            <div className="footer-contact-info">
              <p><strong>{t('footer.contact.email')}</strong></p>
              <p><strong>{t('footer.contact.phone')}</strong></p>
              <p><strong>{t('footer.contact.address')}</strong></p>
            </div>
          </div>
          
          {/* Map Column */}
          <div className="footer-column footer-map-column">
            <h4 className="footer-title">{t('footer.map.title')}</h4>
            <div className="footer-map-container">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1311.9135420510315!2d39.18675024169395!3d21.56046450378454!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15c3d048f815cca1%3A0x6f371b92f70dd95a!2z2YXYsdmD2LIg2KfZhNi52KfYsNix2YrYqSDYqNmE2KfYstin!5e0!3m2!1sen!2ssa!4v1759057003865!5m2!1sen!2ssa"
                width="100%"
                height="300"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="United Ayaat Location"
              ></iframe>
            </div>
          </div>
        </div>
        
        {/* Copyright */}
        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} Ayaat.co. {t('footer.rights')}</p>
          <div className="footer-legal">
            <a href="https://ayaat.co/privacy-policy" target="_blank" rel="noreferrer">
              {t('footer.privacy')}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
